export default __webpack_public_path__ + "static/media/N 프로페셔널 - 블랙.bcfbfb69.png";